import { Box, Skeleton } from '@mui/material'
import CardWithSpace from '../../components/Cards/CardWithSpace'
import { createArrayOfNumbers } from '../../utils/helpers'

const BatchStatusListSkeleton = ({ size = 3 }) => (
  <>
    {[createArrayOfNumbers(size)].map((item) => (
      <CardWithSpace
        key={item}
        customStyles={customStyle.cardWithSideColor}
      >
        <Box sx={customStyle.cardsContainer}>

          <Box sx={customStyle.cardHeader}>
            <Skeleton variant="rounded" sx={customStyle.requestHeaderAvatar} />
            <Skeleton variant="text" sx={customStyle.requestHeader} />
            <Skeleton variant="text" width={90} height={24} />
          </Box>

          <Box sx={customStyle.infoContainer}>
            <Box sx={customStyle.rowFlex}>
              <Skeleton variant="rounded" sx={customStyle.requestInfoAvatar} />
              <Skeleton variant="text" sx={customStyle.requestInfo} />
            </Box>
            <Box sx={customStyle.rowFlex}>
              <Skeleton variant="rounded" sx={customStyle.requestInfoAvatar} />
              <Skeleton variant="text" sx={customStyle.requestInfo} />
            </Box>
            <Box sx={customStyle.rowFlex}>
              <Skeleton variant="rounded" sx={customStyle.requestInfoAvatar} />
              <Skeleton variant="text" sx={customStyle.requestInfo} />
            </Box>
          </Box>
        <Skeleton variant="rounded" sx={customStyle.progressBar} />
        </Box>
        <Skeleton variant="rounded" sx={customStyle.sideButton} />
      </CardWithSpace>
    ))}
  </>
)

const customStyle = {
  cardWithSideColor: {
    backgroundColor: 'transparent',
    p: {
      width: '100% ',
      xs: '5px 20px',
      sm: '16px 8px',
      md: '16px 20px',
      boxSizing: 'border-box',
      padding: {
        xs: '10px', sm: '16px', md: '16px 40px', lg: '16px 40px',
      },
    },
    display: 'flex',
    alignItems: 'center',
    height: { xs: 'auto', md: '197px' },
  },
  cardsContainer: {
    width: '100%',
    gap: { xs: '10px', md: '25px' },
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  requestHeaderAvatar: {
    display: { xs: 'none', sm: 'block' },
    width: '20px',
    height: '20px',
    marginRight: { xs: '15px', sm: '10px' },
  },
  requestHeader: {
    width: '250px',
    height: '24px',
    marginRight: '10px',
    marginLeft: { xs: '10px', sm: 'unset' },
  },
  rowFlex: {
    display: 'flex',
    alignItems: 'center',
  },
  infoContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: { xs: 'column', sm: 'row' },
    padding: { xs: '3px 10px 0px', md: '0px' },
    gap: { xs: '10px', md: '0px' },
  },
  requestInfoAvatar: {
    width: '20px',
    height: '20px',
    marginRight: { xs: '5px', sm: '10px' },
  },
  progressBar: {
    width: { xs: '100%', md: '105%' },
    height: '20px',
  },
  requestInfo: {
    width: '180px',
    height: '24px',
  },
  sideButton: {
    position: { xs: 'absolute', sm: 'relative' },
    right: { xs: '10px', md: '0px' },
    top: { xs: '15px', md: '-45px' },
    width: { xs: '25px', sm: '40px' },
    height: { xs: '5px', sm: '40px' },
  },
}

export default BatchStatusListSkeleton
